import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const paging = (list, pageSize = 10) => {
    const pages = [];

    if (list && Array.isArray(list)) {
        list.forEach((item, index) => {
            const num = Math.floor(index / pageSize);
            const subNum = index % pageSize;

            if (subNum === 0) {
                pages[num] = [];
            }
            pages[num][subNum] = item;
        });
    }

    return pages;
};

class TopBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    constructor(props) {
        super(props);
        const { content } = props;
        const { topData, column } = content;
        let subNav = topData.subNav;
        const columnIdList = column.map((item) => item.wemediaEAccountId);

        subNav = subNav.filter((item) => {
            return !item.onlyIndex;
        });

        subNav.forEach((item) => {
            const { wemediaEAccountId: id } = item;

            item.hasLink = columnIdList.includes(id);
        });

        this.pages = paging(subNav);

        this.state = {
            pageIndex: 0,
        };
    }

    handlePaginationClick = (direction) => {
        // 取消上次动画
        window.cancelAnimationFrame(this.raf);
        // 获取目标索引值
        const { pageIndex } = this.state;
        const { pagesViewRef } = this;
        // 获取一屏的宽度
        const pagesViewLength = pagesViewRef.offsetWidth;
        // 计算移动次数
        const times = 60 * 0.3;

        if (direction === 'right') {
            const newPageIndex = pageIndex + 1;

            this.setState({ pageIndex: newPageIndex });
            // 目标位置
            const target = pagesViewLength * newPageIndex;

            // 计算每次移动的长度
            const step = pagesViewLength / times;
            // requestAnimationFrame的回调函数
            const raf = () => {
                const widthLeft = pagesViewRef.scrollLeft;

                if (widthLeft < target) {
                    const realLeft = Math.abs(widthLeft - target);
                    const realStep = realLeft >= step ? step : realLeft;

                    pagesViewRef.scrollLeft = widthLeft + realStep;
                    this.raf = window.requestAnimationFrame(raf);
                }
            };

            this.raf = window.requestAnimationFrame(raf);
        } else if (direction === 'left') {
            const newPageIndex = pageIndex - 1;

            this.setState({ pageIndex: newPageIndex });
            // 目标位置
            const target = pagesViewLength * newPageIndex;
            // 计算每次移动的长度
            const step = pagesViewLength / times;
            // requestAnimationFrame的回调函数
            const raf = () => {
                const widthLeft = pagesViewRef.scrollLeft;

                if (widthLeft > target) {
                    const realLeft = Math.abs(widthLeft - target);
                    const realStep = realLeft >= step ? step : realLeft;

                    pagesViewRef.scrollLeft = widthLeft - realStep;
                    this.raf = window.requestAnimationFrame(raf);
                }
            };

            this.raf = window.requestAnimationFrame(raf);
        }
    };

    render() {
        const { content } = this.props;
        const { paramName } = content;
        const { pageIndex } = this.state;
        const { pages } = this;

        return (
            <div className={styles.wrap}>
                {/* <div className={styles.titleWrap}>
                    <div className={styles.titleIcon} />
                    <div className={styles.title}>金牌栏目</div>
                </div> */}
                <div className={styles.pageViewWrap}>
                    <div className={styles.pagination}>
                        <div className={styles.paginationFlex}>
                            {pages.length > 1 ? (
                                <>
                                    {pageIndex > 0 ? (
                                        <div
                                            className={`${styles.arrow} ${styles.arrowLeft}`}
                                            onClick={() => {
                                                this.handlePaginationClick('left');
                                            }}
                                        />
                                    ) : (
                                        <div className={`${styles.arrow} ${styles.arrowLeft} ${styles.disabled}`} />
                                    )}
                                    {pageIndex < pages.length - 1 ? (
                                        <div
                                            className={`${styles.arrow} ${styles.arrowRight}`}
                                            onClick={() => {
                                                this.handlePaginationClick('right');
                                            }}
                                        />
                                    ) : (
                                        <div className={`${styles.arrow} ${styles.arrowRight} ${styles.disabled}`} />
                                    )}
                                </>
                            ) : null}
                        </div>
                    </div>
                    <div
                        className={`${styles.pagesView}  ${pages.length > 1 ? styles.pagesViewPadding : ''}`}
                        ref={(ref) => (this.pagesViewRef = ref)}>
                        <div
                            className={`${styles.pagesScroll} ${
                                pages[pageIndex] && pages[pageIndex].length > 5
                                    ? styles.pagesScrollRow2
                                    : styles.pagesScrollRow1
                            }`}>
                            {pages.map((page, index) => {
                                return (
                                    <div className={styles.page} key={index}>
                                        {page.map((item, index) => {
                                            return (
                                                <div className={styles.pageItem} key={index}>
                                                    {item.hasLink ? (
                                                        /* eslint-disable */
                                                        <a
                                                            href={`${basepath}/${paramName}/${item.wemediaEAccountId}`}
                                                            target="_blank"
                                                            className={styles.pageItemLink}>
                                                            <div className={styles.pageItemThumbnail}>
                                                                <img src={item.thumbnail} alt={item.title} />
                                                            </div>
                                                            <div className={styles.pageItemText}>
                                                                <div className={styles.pageItemTitle}>{item.title}</div>
                                                                <div className={styles.pageItemDesc}>{item.desc}</div>
                                                            </div>
                                                        </a>
                                                        /* eslint-enable */
                                                    ) : (
                                                        <div className={styles.pageItemLink}>
                                                            <div className={styles.pageItemThumbnail}>
                                                                <img src={item.thumbnail} alt={item.title} />
                                                            </div>
                                                            <div className={styles.pageItemText}>
                                                                <div className={styles.pageItemTitle}>{item.title}</div>
                                                                <div className={styles.pageItemDesc}>{item.desc}</div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(TopBox);
